import React, { Component } from 'react';
import ProgressStat from './ProgressStat';
import _ from 'lodash';

import '../styles/WorkoutStats.css';
import lineGraph from '../assets/icons8-combo-chart-40.png';
import barbell from '../assets/icons8-dumbbell-40.png'

import weight from '../assets/weight/icons8-weight-40.png';
import car from '../assets/weight/icons8-car-80.png';
import truck from '../assets/weight/icons8-truck-40.png';
import airport from '../assets/weight/icons8-airport-40.png';
import spaceShuttle from '../assets/weight/icons8-space-shuttle-40.png';

import abacus from '../assets/counting/icons8-abacus-40.png';
import typewriter from '../assets/counting/icons8-typewriter-with-paper-40.png';
import calculator from '../assets/counting/icons8-calculator-40.png';
import touchscreen from '../assets/counting/icons8-touchscreen-40.png';
import monitor from '../assets/counting/icons8-monitor-40.png';


import bluePin from '../assets/distance/icons8-marker-40-blue.png';
import greenPin from '../assets/distance/icons8-marker-40-green.png';
import yellowPin from '../assets/distance/icons8-marker-40-yellow.png';
import redPin from '../assets/distance/icons8-marker-40-red.png';
import globe from '../assets/distance/icons8-globe-40.png';

const colorSet = [
  '#98ccfd', '#2ecc71', '#f1c40f', '#e74c3c', '#98ccfd'
]


let weightObj = {
  color: colorSet[2],
  percentage: 65,
  number: '33245',
  max: '300000',
  unit: 'lbs',
  verb: 'Lifted',
  icon: truck,
  markers: [
    weight, car, truck, airport, spaceShuttle
  ]
}

let distance = {
  color: colorSet[0],
  percentage: 24,
  number: '33245',
  max: '50000',
  unit: 'm',
  verb: 'Travelled',
  icon: bluePin,
  markers: [
    bluePin, greenPin, yellowPin, redPin, globe
  ]
}

let reps = {
  color: colorSet[1],
  percentage: 33,
  number: '33245',
  max: '30000',
  unit: 'reps',
  verb: 'Reps',
  icon: typewriter,
  markers: [
    abacus, typewriter, calculator, touchscreen, monitor
  ]
}

const addVals = (obj) => {
  let starter = 0;
  _.flatMap(obj, (val) => {
    starter += val; 
  });

  return starter;
}

class WorkoutStats extends Component {
  constructor(props){
    super(props);

    this.state = {
      stats: 3
    }

    this.progressStuff = this.progressStuff.bind(this);
  }

  progressStuff() {
    let progressArray = [];

    if(!this.props.workoutObj.movement_stats) return;
    reps.number = addVals(this.props.workoutObj.movement_stats.reps);
    weightObj.number = addVals(this.props.workoutObj.movement_stats.weights);
    distance.number = addVals(this.props.workoutObj.movement_stats.distance);

    let datasets = [distance, reps, weightObj];
    
    for(let i = 0; i < 3; i++) {
      progressArray.push(<ProgressStat key={i} stats={datasets[i]} index={i} />)
    }

    return progressArray;
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.workoutObj.movement_stats);
  }

  render() {
    if(!this.props.workoutObj) return(
      <div className="light-blue-border no-left-border h-100">
        <h2>No workouts for selected tracks!</h2>
      </div>
    );

    if(!this.props.workoutObj.title && !this.props.workoutObj.workout_name) return(
      <div className="light-blue-border no-left-border h-100">
        <h2>No workouts for selected tracks!</h2>
      </div>
    );
      
    return(
      <div className="h-100">
        <div className="workout-half light-blue-border no-left-border no-bottom-border relative ph3 tl h-40">
          <div className="title-hack absolute flex justify-center items-center w-100">
            <img className="white mt2 pl2 pr2" height="32" width="32" src={barbell} />
            <h4 className="mt2 mb0 pl2 pr2 white b roboto"> 
              WOD{this.props.amountOfWorkouts > 1  
                ? ('s ' + (this.props.workoutIdx + 1) + '/' + this.props.amountOfWorkouts) 
                : ''}
            </h4>
          </div>
          <h2 className="title relative mt3 mb2 b">{this.props.workoutObj.title ? this.props.workoutObj.title : this.props.workoutObj.workout_name}</h2>
          {(this.props.workoutObj.workout_description) &&
            <div>
              {this.props.workoutObj.title &&
                <h4>{this.props.workoutObj.workout_name}</h4>
              }
              <div>
                {this.props.workoutObj.workout_description.split('\n').map((row, idx) =>
                  <p className="mv0" key={idx}>{row}</p>
                )}
              </div>
            </div>
          }
          {(this.props.workoutObj.notes) &&
            <div>
              <h4>{this.props.workoutObj.workout_name}</h4>
              <div>
                {this.props.workoutObj.notes.split('\n').map((row, idx) =>
                  <p className="mv0" key={idx}>{row}</p>
                )}
              </div>
            </div>
          }
        </div>
        <div className="stats-wrap light-blue-border no-left-border stats-half relative pl3 h-60 w-100">
          <div className="title absolute top--15 flex justify-center items-center w-100">
            <img className="white pl2 pr2" height="32" width="32" src={lineGraph} /><h4 className="mt2 mb0 pl2 pr2 white b roboto"> Stats</h4>
          </div>
          <div className="stats-body relative h-100">
            <div className="absolute top-50 pr4 w-100 transformY--50">
              {this.progressStuff()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WorkoutStats;


// WEBPACK FOOTER //
// ./src/components/WorkoutStats.js